module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAABHNCSVQICAgIfAhkiAAAAHRJREFUGFdjZCAC/P//vwCoLB6IHRkZGT+AtDASoY8BqNEAqO4AEN+HaSZKI8hwDM1AgQ1AcX5ibAaq4QFikO3vGYEaG4AMByI1SgDVqQPxM1KcmgDUMB+IL4IsIkoj0FUgF+2HawKGLLEaA4CaQDYmwKIDAPnpKewGcts2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-arrow.png
// module id = vW68
// module chunks = 34